import { createContext, useContext } from 'react';

export type WidgetVariant = 'hosted' | 'embed';

const WidgetVariantContext = createContext<WidgetVariant>('embed');

export const WidgetVariantProvider = WidgetVariantContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components
export function useWidgetVariant(): WidgetVariant {
  return useContext(WidgetVariantContext);
}
